import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

function baseProps(props: IconProps) {
  return {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
    ...props,
  } as const
}

/** Shopping bag — matches mobile Buy tab (Phosphor ShoppingBag). */
export function HeaderNavIconBuy(props: IconProps) {
  return (
    <svg {...baseProps(props)} className={`vc-header-mobile-link__icon-svg${props.className ? ` ${props.className}` : ''}`}>
      <path
        d="M6 8h12l-1.2 11H7.2L6 8Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M9 8V6.5a3 3 0 0 1 6 0V8"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/** Phone + plus — matches mobile Sell tab. */
export function HeaderNavIconSell(props: IconProps) {
  return (
    <svg {...baseProps(props)} className={`vc-header-mobile-link__icon-svg vc-header-mobile-link__icon-svg--sell${props.className ? ` ${props.className}` : ''}`}>
      <rect
        x="7"
        y="3.5"
        width="10"
        height="17"
        rx="2.2"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path d="M10.5 18.5h3" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <circle cx="17.5" cy="17" r="4.25" fill="var(--bg-elevated, #fff)" stroke="currentColor" strokeWidth="1.5" />
      <path d="M17.5 14.8v4.4M15.3 17h4.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

/** Magnifying glass — mobile menu search. */
export function HeaderNavIconSearch(props: IconProps) {
  return (
    <svg {...baseProps(props)} className={`vc-header-mobile-link__icon-svg${props.className ? ` ${props.className}` : ''}`}>
      <circle cx="11" cy="11" r="6.25" stroke="currentColor" strokeWidth="1.75" />
      <path d="M15.8 15.8 20 20" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  )
}

/** User — mobile menu account / profile. */
export function HeaderNavIconAccount(props: IconProps) {
  return (
    <svg {...baseProps(props)} className={`vc-header-mobile-link__icon-svg${props.className ? ` ${props.className}` : ''}`}>
      <circle cx="12" cy="8.75" r="3.25" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M6 20v-1c0-3.1 2.7-5.25 6-5.25s6 2.15 6 5.25v1"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/** Shield check — matches mobile Check tab. */
export function HeaderNavIconCheck(props: IconProps) {
  return (
    <svg {...baseProps(props)} className={`vc-header-mobile-link__icon-svg${props.className ? ` ${props.className}` : ''}`}>
      <path
        d="M12 3.5 18.5 6v5.8c0 3.6-2.4 6.9-6.5 8.2C7.9 18.7 5.5 15.4 5.5 11.8V6L12 3.5Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="m9.2 12 1.8 1.8 3.6-3.7"
        stroke="currentColor"
        strokeWidth="1.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
